const tournamentReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default tournamentReducer;
